<template>
    <div>
        <a-modal v-model:visible="show" title="手机验证" @ok="handleOk()" @cancel="handleClose()" width="100%">
            <a-form ref="formData" :rules="formDataRules" layout="horizontal" :model="formData" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-row justify="center">
                    <a-col :xs="24" :lg="8">
                        <a-form-item label="手机号" name="mobile">
                            {{ formData.mobile }}
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row justify="center">
                    <a-col :xs="24" :lg="8">
                        <a-form-item label="验证码" name="code">
                            <a-input-search v-model:value="formData.code" placeholder="请输入验证码" @search="getMobileVerifyCode()">
                                <template #enterButton>
                                    <a-button type="primary">
                                        <span v-if="seconds <= 0">获取验证码</span>
                                        <span v-else>验证码已发送（{{ seconds }}）</span>
                                    </a-button>
                                </template>
                            </a-input-search>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    import { hideMobile } from '@/tool/common';
    import { GetMobileVerifyCode, VerifyCode } from '@/api/users';
    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            mobile: {
                type: String,
                default: ""
            },
        },
        data() {
            return {
                labelCol: { span: 5 },
                wrapperCol: { span: 14 },
                show: false,
                formData: {},
                seconds: 0,
                formDataRules: {
                    mobile: [
                        { required: true, message: '请输入手机号!' },
                        { pattern: /^1[3456789]\d{9}$/ ,message: '手机号码格式不正确', trigger: 'change' }
                    ],
                    code: [
                        { required: true, message: '请输入手机验证码!' },
                        { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'change'},
                    ],
                }
            }
        },
        watch: {
            visible(n) {
                this.show = n   
            },
            mobile(n) {
                this.formData.mobile = hideMobile(n)
            }
        },
        created() {
            this.formData.mobile = hideMobile(this.mobile)
        },
        methods: {
            handleOk() {
                let _this = this
                VerifyCode({
                    code: _this.formData.code
                }).then((result) => {
                    if(result.code) {
                        _this.$message.error({
                            duration: 1,
                            content: result.message,
                        });
                        return
                    }
                    _this.$message.success({
                        duration: 1,
                        content: result.message,
                    });
                    localStorage.setItem("is-validate-mobile-time",new Date().getTime() + 60 * 10 * 1000)
                    localStorage.setItem("is-validate-mobile",1)
                    _this.$emit("ok")
                })

            },
            handleClose() {
                this.$emit("close")
            },
            getMobileVerifyCode() {
                let _this = this
                GetMobileVerifyCode().then((result) => {
                    if(result.code) {
                        _this.$message.error({
                            duration: 1,
                            content: result.message,
                        });
                        return
                    }
                    _this.$message.success({
                        duration: 1,
                        content: result.message,
                    });
                    _this.seconds = 60
                    let isInter = setInterval(() => {
                        if(_this.seconds == 0) {
                            _this.seconds = 0
                            clearInterval(isInter)
                        }
                        _this.seconds = _this.seconds - 1
                    },1000)
                })
            }
        }
    }
</script>